<template>
  <div>
    <div class="content">
      <!-- <button @click="generateResumeDocument">Download Resume</button> -->
      <div class="contentRit">
        <div class="headCont">
          <div class="box">
            <div class="shu"></div>
            <div class="txt">公司内部人员</div>
          </div>
          <div class="btn dis-cent" @click="peoAddShow = true">添加成员</div>
        </div>
        <div class="contBox">
          <div class="zCont" v-for="(item, index) in userlist">
            <div class="cont">
              <div class="peoBox">
                <div class="img">
                  <img :src="$imgUrl + item.avatars" />
                </div>
                <div class="box">
                  <div class="name">{{ item.member_info.realname }}</div>
                </div>
              </div>
              <div class="mobileBox">
                <div class="txt">{{ item.member_info.phone }}</div>
                <div
                  class="iconfont icon-fuzhi_o fuzhi_o"
                  @click="phoFz(item.member_info.phone)"
                ></div>
              </div>
              <div class="zhuangtai">
                <div class="yuan"></div>
                <div class="name">{{ index == 0 ? "主要负责人" : "HR" }}</div>
              </div>
              <div class="funCont">
                <a-popconfirm
                  title="是否发送微信"
                  ok-text="是"
                  cancel-text="否"
                  v-if="quanxian && index != 0"
                  @confirm="bjClick(item.id)"
                >
                  <div class="text">转让负责人</div>
                </a-popconfirm>
                <a-popconfirm
                  title="是否确定删除此人员"
                  ok-text="是"
                  cancel-text="否"
                  v-if="quanxian && index != 0"
                  @confirm="delClick(item.id)"
                >
                  <div class="text">删除</div>
                </a-popconfirm>
              </div>
            </div>
          </div>
        </div>
        <div class="headCont" v-if="list.length != 0">
          <div class="shu"></div>
          <div class="txt">人员申请</div>
        </div>
        <div class="contBox">
          <div class="zCont" v-for="(item, index) in list">
            <div class="cont">
              <div class="peoBox">
                <div class="img">
                  <img :src="$imgUrl + item.member.avatars" />
                </div>
                <div class="box">
                  <div class="name">{{ item.member.realname }}</div>
                </div>
              </div>
              <div class="mobileBox">
                <div class="txt">{{ item.member.mobile }}</div>
                <div
                  class="iconfont icon-fuzhi_o fuzhi_o"
                  @click="phoFz(item.member.mobile)"
                ></div>
              </div>
              <div class="zhuangtai">
                <!-- <div class="yuan"></div>
                <div class="name">主要负责人</div> -->
              </div>
              <div class="funCont">
                <a-popconfirm
                  title="是否同意该申请"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="tongyiClick(item.id)"
                >
                  <div class="text">同意</div>
                </a-popconfirm>
                <a-popconfirm
                  title="是否拒绝该申请"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="jujueClick(item.id)"
                >
                  <div class="text red">拒绝</div>
                </a-popconfirm>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PeoAdd v-if="peoAddShow" @show="peoShowJs" />
  </div>
</template>

<script>
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  AlignmentType,
  Table,
  TableRow,
  TableCell,
  ImageRun,
  BorderStyle,
  VerticalAlign,
  HeightRule,
} from "docx";
import { saveAs } from "file-saver";
import PeoAdd from "../../component/peoAdd.vue";
export default {
  name: "",
  components: {
    PeoAdd,
  },
  data() {
    return {
      avatarBase64: "https://suzkj.com/static/avatar/tx2.png",
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 30,
      },
      list: [],
      userlist: [],
      totalCount: 0,
      quanxian: false,
      peoAddShow: false,
    };
  },
  created() {
    this.userlistGet();
    this.listGet();
  },
  methods: {
    peoShowJs(data) {
      this.peoAddShow = false;
      if (data.type) {
        this.userlistGet();
      }
    },
    phoFz(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
    },
    userlistGet() {
      this.$get("/nozzle/web/company_manage").then((res) => {
        console.log(res);

        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
          }
          this.userlist = res.data;
        }
        this.quanxian = res.quanxian;
      });
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/company_apply_member", this.page).then((res) => {
        this.judge = true;
        this.list = res.data ? res.data : [];
      });
    },
    bjClick(id) {
      this.$post("/nozzle/web/company_transfer", {
        member_id: id,
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message.success("操作成功");
          this.listGet();
          this.userlistGet();
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    delClick(id) {
      this.$post("/nozzle/web/company_delete_staff", {
        member_id: id,
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message.success("操作成功");
          this.listGet();
          this.userlistGet();
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    tongyiClick(id) {
      this.$post("/nozzle/web/company_apply_agree", {
        id: id,
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message.success("操作成功");
          this.listGet();
          this.userlistGet();
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    jujueClick(id) {
      this.$post("/nozzle/web/company_apply_refuse", {
        id: id,
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message.success("操作成功");
          this.listGet();
          this.userlistGet();
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    getBase64Image(imgUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imgUrl;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        };
        img.onerror = (error) => reject(error);
      });
    },
    async generateResumeDocument() {
      try {
        const imageBase64 = await this.getBase64Image(this.avatarBase64);
        // 创建文档
        const doc = new Document({
          sections: [
            {
              children: [
                // 头像段落
                new Paragraph({
                  children: [
                    new ImageRun({
                      data: imageBase64,
                      transformation: { width: 100, height: 100 },
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                  spacing: { after: 200 }, // 增加头像与其他内容的间距
                }),

                // 姓名段落
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "林传博",
                      bold: true,
                      size: 28,
                      color: "000000", // 蓝色字体
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                  spacing: { after: 100 }, // 姓名与联系方式之间的间距
                }),

                // 联系方式段落
                new Paragraph({
                  children: [
                    new TextRun("电话: 15868653801 、 "),
                    new TextRun("邮箱: johndoe@example.com 、 "),
                    new TextRun("性别: 男 、 "),
                    new TextRun("籍贯: 台州"),
                  ],
                  alignment: AlignmentType.CENTER,
                  spacing: { after: 200 }, // 增加与下部分内容的间距
                }),

                // 求职意向标题
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "求职意向",
                      bold: true,
                      size: 28,
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                  spacing: { after: 100 }, // 增加标题与内容的间距
                }),

                // 求职意向内容
                new Table({
                  rows: [
                    // 表头
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望职位", size: 20 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER, // 垂直居中
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望行业", size: 20 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望地点", size: 20 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望薪资", size: 20 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                      ],
                    }),
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望职位", size: 16 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER, // 垂直居中
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望行业", size: 16 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望地点", size: 16 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望薪资", size: 16 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: "pct" }, // 设置表格宽度为100%
                  spacing: { after: 200 },
                }),

                // 工作经历标题
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Work Experience",
                      bold: true,
                      size: 28,
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                  spacing: { after: 100 },
                }),

                // 工作经历表格
                new Table({
                  rows: [
                    // 表头
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph("Company")],
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.SINGLE },
                          },
                        }),
                        new TableCell({
                          children: [new Paragraph("Position")],
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.SINGLE },
                          },
                        }),
                        new TableCell({
                          children: [new Paragraph("Duration")],
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.SINGLE },
                          },
                          alignment: AlignmentType.RIGHT, // 右对齐时间
                        }),
                      ],
                    }),
                    // 第一行工作经历
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph("Tech Corp")],
                        }),
                        new TableCell({
                          children: [new Paragraph("Software Engineer")],
                        }),
                        new TableCell({
                          children: [new Paragraph("2019 - Present")],
                          alignment: AlignmentType.RIGHT,
                        }),
                      ],
                    }),
                    // 第二行工作经历
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph("Code Factory")],
                        }),
                        new TableCell({
                          children: [new Paragraph("Junior Developer")],
                        }),
                        new TableCell({
                          children: [new Paragraph("2017 - 2019")],
                          alignment: AlignmentType.RIGHT,
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: "pct" }, // 设置表格宽度为100%
                }),

                // 技能部分
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Skills",
                      bold: true,
                      size: 28,
                      underline: { type: "single" },
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                  spacing: { before: 200, after: 100 },
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "• JavaScript, TypeScript, Vue.js, Node.js\n• HTML5, CSS3, Sass\n• Git, Docker, AWS",
                      size: 24,
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                }),
              ],
            },
          ],
        });

        // 生成并下载 Word 文档
        const buffer = await Packer.toBlob(doc);
        saveAs(buffer, "resume.docx");
      } catch (error) {
        console.error(
          "An error occurred while generating the Word document:",
          error
        );
        alert(
          "An error occurred while generating the document. Please try again."
        );
      }
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  margin: auto;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  height: calc(100vh - 185px);
  overflow: auto;
  width: 100%;
  max-width: 1280px;
  .contentLeft {
    width: 350px;
    border-right: 1px solid #ebebeb;
    .cont {
      height: 300px;
    }
    .text {
      color: #9c9c9c;
      padding: 10px 15px;
    }
  }
  .contentRit {
    box-sizing: border-box;
    width: 100%;
    .headBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 70px;
      padding: 0 20px;
      .name {
        font-weight: 600;
        font-size: 20px;
      }
      .cont {
        display: flex;
        align-items: center;
        .box {
          margin-left: 20px;
          border-radius: 5px;
          background-color: #eef4fc;
          height: 35px;
          width: 150px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .text {
            width: calc(100% - 20px);
            padding-left: 12px;
            box-sizing: border-box;
          }
          .iconfont {
            font-size: 12px;
          }
        }
      }
    }
    .headCont {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      padding-bottom: 0;
      .box {
        display: flex;
        align-items: center;
        .shu {
          height: 22px;
          border-radius: 5px;
          width: 5px;
          background-color: #1596ff;
        }
        .txt {
          font-weight: 600;
          font-size: 18px;
          margin-left: 10px;
        }
      }
      .btn {
        width: 75px;
        height: 35px;
        border-radius: 5px;
        background-color: #1a78ec;
        color: #fff;
        cursor: pointer;
      }
    }
    .contBox {
      // height: calc(100% - 70px);
      overflow: auto;
      box-sizing: border-box;
      padding: 20px 20px 0;
      .zCont {
        margin-bottom: 20px;
        .shijian {
          margin-bottom: 10px;
          font-size: 16px;
        }
      }
      .cont {
        border-radius: 10px;
        border: 1px solid #ebebeb;
        height: 90px;
        padding: 0 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .time {
          width: 70px;
          font-size: 18px;
          color: #666;
        }
        .peoBox {
          height: 45px;
          width: 150px;
          display: flex;
          .img {
            width: 45px;
            border-radius: 50%;
            height: 45px;
          }
          .box {
            display: flex;
            align-items: center;
            padding-left: 10px;
            width: calc(100% - 45px);
            box-sizing: border-box;
            padding-right: 10px;
            .text {
              font-size: 12px;
              color: #9c9c9c;
            }
          }
        }
        .mobileBox {
          display: flex;
          align-items: center;
          width: 150px;
          .fuzhi_o {
            font-size: 20px;
            position: relative;
            top: 1px;
            margin-left: 5px;
            color: #299fff;
            cursor: pointer;
          }
        }
        .gwBox {
          width: calc(100% - 500px);
        }
        .zhuangtai {
          display: flex;
          align-items: center;
          width: 100px;
          .yuan {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #1a78ec;
            margin-right: 5px;
          }
        }
        .funCont {
          width: calc(100% - 400px);
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .text {
            margin-right: 20px;
            color: #1a78ec;
            cursor: pointer;
          }
          .more {
            font-size: 24px;
            color: #9c9c9c;
            cursor: pointer;
          }
        }
        .ztBox {
          width: 200px;
          display: flex;
          justify-content: center;
          align-items: center;
          .yuan {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background-color: #1596ff;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
</style>
